import { default as actionCreatorFactory } from 'typescript-fsa';
import { EvaluatedResponse, ContentSetup, ProgressLoaded } from '../../utils';

import { LessonKeys } from '../../appcfg';

const actionCreator = actionCreatorFactory('progression');

export const nextProblemChosen = actionCreator<ContentSetup>(
  'NEXT_PROBLEM_CHOSEN'
);

/**
 * Request to start a new question/problem with the given question content data.
 */
export const nextPageTypeAction = actionCreator<ContentSetup>(
  'DIFFICULTY_INCREASED'
);
export const nextProblemTypeReached = actionCreator<ContentSetup>(
  'NEXT_PROBLEM_TYPE_REACHED'
);
export const responseEvaluated = actionCreator<EvaluatedResponse>(
  'RESPONSE_EVALUATED'
);
export const progressionEndReached = actionCreator<boolean>(
  'PROGRESSION_END_REACHED'
);
export const progressStateLoading = actionCreator('PROGRESS_STATE_LOADING');
export const progressStateLoaded = actionCreator<ProgressLoaded>(
  'PROGRESS_STATE_LOADED'
);

/**
 * Go to a specific problem.
 * 
 * payload is [progressionIndex, difficulty level (usually between 0-2)]
 */
export const forceProblemType = actionCreator<[number, number]>('FORCE_PROBLEM_TYPE');

export const switchModule = actionCreator<LessonKeys>('SWITCH_MODULE');

export const getModuleTips = actionCreator('GET_MODULE_TIPS');
export const incrementCorrectAnswer = actionCreator<number>(
  'INCREMENT_CORRECT_ANSWER'
);
export const resetMastery = actionCreator('RESET_MASTERY');
